import styled from 'styled-components';
import Shadow from 'products/global/assets/img/nest/egg-shadow.png';
import Button from 'components/Button';
import Modal from 'components/Modal';
import { motion } from 'framer-motion';
import { th } from 'style/theme';
import { sizes } from 'style';

// magic numbers to center the content in the uneven nest background
export const NestContent = styled(motion.div)`
  margin-top: 34%;
  width: calc(100% - 26%);
  margin-left: 14%;
  margin-bottom: 20%;
`;

export const NestItemsWrapper = styled(motion.div)`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-auto-rows: 1fr;
  grid-gap: 15px 10px;
`;

export const NestItem = styled(motion.div)`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
  ${({ isClickable }) => isClickable && `cursor: pointer`};
`;

export const EggImg = styled(motion.img)`
  z-index: 2;
  height: 80px;
  width: auto;
  padding: 0 2px;

  @media ${sizes.mobileMedium} {
    height: 100px;
  }

  @media ${sizes.tabletPortrait} {
    height: 130px;
  }
`;

export const EggShadow = styled.img.attrs({ src: Shadow })`
  position: absolute;
  width: 70%;
  bottom: 22%;
  height: auto;
  z-index: 1;
`;

export const NestItemHeading = styled.div`
  z-index: 2;
  width: 85%;
  padding: 4px 8px;
  margin-top: 8px;
  border-radius: 8px;
  box-shadow: ${th('shadows.small')};
  background-color: ${th('colors.black')};
  color: ${th('colors.white')};
  display: flex;
  justify-content: space-between;

  > span {
    font-size: 14px;
  }
`;

export const PopupModal = styled(Modal)`
  width: 500px;
`;

export const ModalButton = styled(Button)`
  margin-top: 24px;
  white-space: pre;
`;
